import { CellProps } from 'react-table';
import { useTranslation } from 'react-i18next';

import { Button, DataTableColumns, VisuallyHidden } from '@tq/ui-components';

import { useNavigate } from 'hooks';
import { Consultee } from 'types';

export const useManageUsersColumns = (): DataTableColumns<Consultee>[] => {
  const { t } = useTranslation('manage_teams');
  const { navigateToTeamUsers } = useNavigate();

  return [
    {
      accessor: 'consulteeName',
      disableSortBy: false,
      Header: () => t('name', 'Name'),
      width: 280,
    },
    {
      accessor: 'email',
      disableSortBy: true,
      Header: () => t('email', 'Email'),
      width: 280,
    },
    {
      accessor: 'teams[0].organisationName',
      disableSortBy: true,
      Header: () => t('organisation', 'Organisation'),
      width: 280,
    },
    {
      accessor: 'permissionName',
      disableSortBy: true,
      Header: () => t('permissions', 'Permissions'),
      width: 180,
    },
    {
      id: 'isRegistered',
      accessor: (d) => {
        return d.isRegistered ? 'Yes' : 'No';
      },
      disableSortBy: true,
      Header: () => t('is_registered', 'Is registered'),
      width: 180,
    },
    {
      accessor: 'msgDetail',
      disableSortBy: true,
      Header: () => <VisuallyHidden>{t('manage_header', 'Manage')}</VisuallyHidden>,
      width: 100,
      Cell: ({ row: { original } }: CellProps<Consultee>) => (
        <Button
          variant='secondary'
          size='xs'
          onClick={() =>
            original?.teams[0]?.organisationId &&
            navigateToTeamUsers(original.teams[0].organisationId)
          }
        >
          {t('manage', 'Manage')}
        </Button>
      ),
    },
  ];
};
